import React from 'react';

import { FancyRadio } from '@rover/components/src/formFields/FancyRadioGroup';

type Props = React.ComponentProps<typeof FancyRadio> & {
  noExtraPadding?: boolean;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function UnifiedFancyRadio({ noExtraPadding, ...rest }: Props): JSX.Element | null {
  return <FancyRadio {...rest} />;
}

export default UnifiedFancyRadio;
